// extracted by mini-css-extract-plugin
export default {"container":"DeleteLanguage_container__GjZn8"};